/**
 * EU食品添加物画面用文字列、エレメント
*/

// 文字列
export const constantsMsg = {
    STR_ERROR: "例外が発生しました。管理者にお問い合わせください。",
    STR_PLZ_SELECT: "お選びください",
    STR_PLZ_SELECT_ADDITIVE_NAME: "※添加物名を選択してください",
    STR_RESULT_NOTFOUND: "本カテゴリーにおいて当該添加物は使用が認められていません。",
    STR_MODAL_NOTFOUND: "該当データが見つかりませんでした。管理者にお問い合わせください。",
    STR_MODAL_LINK: "この添加物は個別にまたは組み合わせて添加することができます。\nクリックして詳細を確認してください。",
    STR_MODAL_TITLE: "組み合わせて使用されることで規制される可能性のあるその他の添加物",
};

// カテゴリー項目名
export const constantsCategory = {
    STR_PRIMARY: "大項目",
    STR_SECONDARY: "中項目",
    STR_TERTIARY: "小項目",
    STR_QUATERNARY: "細項目",
};

// エレメント
export const constantsElement = {
    TXT_01: <p>
                「EU食品添加物データベース」では、EUで加工食品等に使用できる添加物に関する基準値を参照できます。<br />
                ※基準値はEUのWebサイト等信頼できると思われる各種情報に基づいて作成しておりますが、その正確性、完全性を保証するものではありません。<br />
                本データは、調査時点（令和3年11月時点）の情報であり、その後変更されていることがあります。事前に最新の輸出先国・地域の関係法規を確認してください。
            </p>,

    TXT_02: <p style={{ padding: "20px" }}>
                本サイトで取扱う食品添加物は、日本国内での使用可否に関らず、EUで使用可能な食品添加物を掲載しています。<br />
                また、掲載している食品添加物に、食品酵素や香料は含まれません。<br />
                EUにおける食品添加物の使用基準は、食品カテゴリー毎に細かく規制されている事に加え、食品カテゴリー毎に、キャリーオーバーであっても添加物や着色料の使用が認められていない場合もあるため、
                <a href="https://www.maff.go.jp/j/shokusan/export/eu_add_data.html" style={{ color: "#0000EE", textDecoration: "underline" }} >こちら</a>もご確認ください。
            </p>,

    TXT_03: <p style={{ padding: "20px" }}>
                EUでは、食品添加物の使用基準が食品ごとに決められており、食品カテゴリーとして整理しています。該当製品のEUにおけるカテゴリーについては
                <a href="https://www.maff.go.jp/j/shokusan/export/attach/pdf/eu_add_data-3.pdf" target="_blank" style={{ color: "#0000EE", textDecoration: "underline" }} >こちら</a>を参照してください。
            </p>
};

// メタデータ
export const constantsMet = {
    title: "EU食品添加物データベース検索｜海外の食品規則チェックサイト- OMARS",
    description: "EU食品添加物データベース検索では、EUへ輸出する加工食品等に使用できる添加物に関する基準値を参照できます",
    keywords: "EU添加物,要件,規制,検索",

    og_title: "EU食品添加物データベース検索｜海外の食品規則チェックサイト- OMARS",
    og_description: "EU食品添加物データベース検索では、EUへ輸出する加工食品等に使用できる添加物に関する基準値を参照できます",

    og_url: "https://export-regulations.maff.go.jp/D0131FoodAdditive",
    og_site_name: "EU食品添加物データベース検索｜海外の食品規則チェックサイト- OMARS",
};